import React from 'react';
import { Link } from 'react-router-dom';

const DashboardStatGroup = ({ title, icon, link, metrics }) => {
  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-4">
      <div className="card dash-card h-100">
        <div className="dash-card-header">
          <span className="dash-card-header-title">
            {icon}
            <span>{title}</span>
          </span>
          {link && <Link to={link} className="dash-view-link">View All</Link>}
        </div>
        <div className="dash-card-body d-flex">
          {metrics.map((metric, idx) => (
            <div key={idx} className="dash-metric">
              <div className={`dash-metric-value dash-clr-${metric.color || 'default'}`}>{metric.value}</div>
              <div className="dash-metric-label">{metric.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardStatGroup;
